import { render, staticRenderFns } from "./OrganizationDropdownField.vue?vue&type=template&id=e90e9760"
import script from "./OrganizationDropdownField.vue?vue&type=script&lang=ts"
export * from "./OrganizationDropdownField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e90e9760')) {
      api.createRecord('e90e9760', component.options)
    } else {
      api.reload('e90e9760', component.options)
    }
    module.hot.accept("./OrganizationDropdownField.vue?vue&type=template&id=e90e9760", function () {
      api.rerender('e90e9760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Dropdowns/OrganizationDropdownField.vue"
export default component.exports